import Reveal from "@/components/site/Reveal";

const steps = [
  {
    title: "Présentation du cadre",
    desc: "Accueil, posture, règles de confidentialité. On pose les bases du travail.",
  },
  {
    title: "Mise en travail d'une problématique",
    desc: "Une personne expose la situation qu'elle souhaite explorer. Le groupe écoute.",
  },
  {
    title: "Observation des dynamiques",
    desc: "Les places sont représentées dans l'espace. Ce qui apparaît est laissé visible.",
  },
  {
    title: "Mise en mouvement",
    desc: "Des ajustements sont proposés pour permettre une circulation différente.",
  },
  {
    title: "Intégration",
    desc: "Temps de retour, de relecture et d'ancrage. Ce qui a été vu est laissé déposer.",
  },
];

export default function HowItWorks() {
  return (
    <section
      data-testid="ateliers-how"
      className="relative py-24 md:py-32 bg-[#3A2E6E] text-white overflow-hidden"
    >
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 left-0 w-[36rem] h-[36rem] rounded-full bg-[#2847B8]/30 blur-[140px]" />
        <div className="absolute bottom-0 right-0 w-[36rem] h-[36rem] rounded-full bg-[#C98FA3]/20 blur-[140px]" />
      </div>
      <div className="relative max-w-6xl mx-auto px-6 md:px-12">
        <Reveal>
          <span className="text-sm uppercase tracking-[0.2em] text-[#C98FA3] font-medium">
            — Méthode
          </span>
          <h2 className="font-serif-display text-4xl md:text-5xl font-light mt-4 leading-[1.05] text-white max-w-2xl">
            Déroulement de l'atelier
          </h2>
        </Reveal>

        <div className="mt-14 space-y-4">
          {steps.map((s, i) => (
            <Reveal key={s.title} delay={i * 0.06}>
              <div
                data-testid={`ateliers-how-step-${i}`}
                className="grid grid-cols-[auto_1fr] gap-6 md:gap-10 items-start p-6 md:p-8 rounded-3xl bg-white/8 backdrop-blur-md border border-white/15 hover:border-[#C98FA3]/60 transition-colors"
              >
                <div className="font-serif-display text-5xl md:text-6xl text-[#C98FA3] leading-none w-14">
                  {String(i + 1).padStart(2, "0")}
                </div>
                <div>
                  <h3 className="font-serif-display text-2xl text-white">{s.title}</h3>
                  <p className="mt-2 text-base text-white/75 leading-relaxed">{s.desc}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
